import { render, staticRenderFns } from "./BaseRadioInputGroup.vue?vue&type=template&id=fb6abcb0&scoped=true&"
import script from "./BaseRadioInputGroup.vue?vue&type=script&lang=ts&"
export * from "./BaseRadioInputGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BaseRadioInputGroup.vue?vue&type=style&index=0&id=fb6abcb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6abcb0",
  null
  
)

export default component.exports